module.exports = __webpack_public_path__ + "static/media/print-blue.fdd5024b.svg";